import { Operator } from '../models/userSettings';

/**
 * @param operators - List of operators, or `undefined` if not loaded/available
 * @returns `false` if at least one operator has `show_google_maps` set to `false`; otherwise `true`
 */
export default function isGoogleMapsEnabledForUserOperators(operators: Operator[] | undefined): boolean {
  if (!operators?.length) {
    return true;
  }
  return !operators.some((op) => op?.operator_setting?.show_google_maps === false);
}
